import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { contexts } from 'constants/context';
import { setContext } from 'modules/common/actions';
import { fetchMember } from 'modules/members/actions';
import MemberProfileView from 'modules/members/views/MemberProfileView';
import initApp from 'utils/functions/init';

const MemberProfilePage = () => {
  const params = useParams();
  const { userEmail } = params;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchMember({ userEmail }));
    dispatch(setContext(contexts.memberProfile));
    initApp();
  }, [dispatch, userEmail]);

  return <MemberProfileView />;
};

export default MemberProfilePage;
